export const pricePage = () => {
  if (document.body.classList.contains("page_price")) {
    document.addEventListener("alpine:init", () => {
      Alpine.data("simulator", () => ({
        price: [],
        priceList: {
          // 各プランの料金
          0: 150000,
          1: 60000,
          2: 5000,
          3: 4000,
          4: 2728,
          5: 10000,
          6: 32637,
          7: 78091,
          8: 114455,
        },
        showOptions: false,
        showPhotoPlans: false,
        handleClickPlans(target = false) {
          if (target) {
            this.uncheck(target);
          }
          this.toggleOptions();
          this.toggleOptionValues();
          this.togglePhotoPlans();
          this.togglePhotoPlanValues();
        },
        // 引数に入れたインデックス番号を配列から削除
        uncheck(target) {
          this.price = this.price.filter((item) => {
            return !target.includes(item);
          });
        },
        // 衣装―式レンタル 姉妹・ママ振小物レンタルが選択されている場合はtrue
        toggleOptions() {
          const values = ["0", "1"];
          this.showOptions = this.price.some((item) => {
            return values.includes(item);
          });
        },
        // レンタルプランの内容が選択されている場合はtrue
        togglePhotoPlans() {
          const values = ["0", "1", "2"];
          this.showPhotoPlans = this.price.some((item) => {
            return values.includes(item);
          });
        },
        // index 3,4,5をpriceから削除
        toggleOptionValues() {
          const optionIndexes = ["3", "4", "5"];
          if (!this.showOptions) {
            this.price = this.price.filter((item) => {
              return !optionIndexes.includes(item);
            });
          }
        },
        // index 6,7,8をpriceから削除
        togglePhotoPlanValues() {
          const photoPlansIndexes = ["6", "7", "8"];
          if (!this.showPhotoPlans) {
            this.price = this.price.filter((item) => {
              return !photoPlansIndexes.includes(item);
            });
          }
        },
        get totalPrice() {
          return this.price.reduce((acc, cur) => acc + Number(this.priceList[cur]), 0);
        },
        get totalPriceWithTax() {
          // 税率を掛けたあと四捨五入
          return this.price.reduce((acc, cur) => acc + Math.floor(Number(this.priceList[cur] * 1.1)), 0);
        },
      }));
    });
  }
};
